<template>
  <div class="avatar-photo">
    <v-avatar :size="previewSize" :tile="tile" :color="value || url ? 'transparent' : 'grey lighten-3'">
      <img v-if="value" :src="avatarFileUrl" alt="avatar">
      <img v-else-if="url" :src="url" alt="avatar">
      <v-icon v-else medium>{{ icon ? icon : '' }}</v-icon>
    </v-avatar>
  </div>
</template>

<script>
export default {
  name: 'Avatar',
  props: {
    url: String,
    value: Blob,
    previewSize: Number,
    tile: Boolean,
    icon: String
  },
  computed: {
    avatarFileUrl: {
      get () {
        return this.value ? URL.createObjectURL(this.value) : ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.avatar-photo {
  max-height: 100px;
  margin: 0px 0px 0px 0px;
  max-width: 100px;

  img {
    // width: auto;
    object-fit: cover;
  }
}
</style>
